const actions = {
    GET_TASK_COPY_HISTORY_REQUEST: "TASK_COPY_HISTORY/GET_TASK_COPY_HISTORY_REQUEST",
    GET_TASK_COPY_HISTORY_SUCCESS: "TASK_COPY_HISTORY/GET_TASK_COPY_HISTORY_SUCCESS",
    GET_TASK_COPY_HISTORY_ERROR: "TASK_COPY_HISTORY/GET_TASK_COPY_HISTORY_ERROR",

    getTaskCopyHistory: (payload) => ({ type: actions.GET_TASK_COPY_HISTORY_REQUEST, payload }),
};

export default actions;
